<script>
    import GeoExample from './GeoExample.svelte';
    import { fetching_gps_data, gps_datapoints, projection } from './store.js';

    export let car;
    export let day;

    let datapoints = []
    $: datapoints = $gps_datapoints.filter(d => { return d.car_id == car & d.day == day})
    

	// $: {
    //     db.query(`
	// 		FOR p IN ja_car_positions
	// 		FILTER p.car_id == ${car}
    //         FILTER p.day == ${day}
	// 		RETURN p
	// 	`).then(
	// 		cursor => cursor.map(doc => doc)
	// 	).then(
	// 		data => datapoints = data
    //     );
    // }

    let augmented_datapoints;
    $: {
        augmented_datapoints = []
        datapoints.forEach(d => {
            d.geo = projection([d.avg_long, d.avg_lat])
            augmented_datapoints = [...augmented_datapoints, d]
        })
    }
</script>

<style>
    circle {
        fill: steelblue
    }
</style>

{car} - {day}<br/>
{#if $fetching_gps_data }
Loading data...
{:else}
<svg width=200 height=200>
    <g transform="translate(100,100) scale(0.2)">
        <GeoExample />
        {#each augmented_datapoints as datapoint}
            <circle cx={datapoint.geo[0]} cy={datapoint.geo[1]} r=4/>
        {/each}
    </g>
</svg>
{/if}